// src/components/EnvironmentSwitcher.js
import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Chip,
  Tooltip,
  IconButton,
} from '@mui/material';
import { Settings } from '@mui/icons-material';
import config, { config as allConfigs } from '../config';

const EnvironmentSwitcher = () => {
  const [currentEnv, setCurrentEnv] = useState(config.ENVIRONMENT);
  const [showDetails, setShowDetails] = useState(false);

  const getEnvironmentColor = (env) => {
    switch (env) {
      case 'development':
        return 'warning';
      case 'production':
        return 'success';
      default:
        return 'default';
    }
  };

  const getEnvironmentIcon = (env) => {
    switch (env) {
      case 'development':
        return '🔧';
      case 'production':
        return '🚀';
      default:
        return '❓';
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Tooltip title={`Current Environment: ${currentEnv.toUpperCase()}`}>
        <Chip
          icon={<span>{getEnvironmentIcon(currentEnv)}</span>}
          label={currentEnv.toUpperCase()}
          color={getEnvironmentColor(currentEnv)}
          size="small"
          variant="outlined"
        />
      </Tooltip>
      
      <Tooltip title="Environment Details">
        <IconButton
          size="small"
          onClick={() => setShowDetails(!showDetails)}
          sx={{ color: 'text.secondary' }}
        >
          <Settings fontSize="small" />
        </IconButton>
      </Tooltip>

      {showDetails && (
        <Box sx={{ 
          position: 'absolute', 
          top: '100%', 
          right: 0, 
          mt: 1, 
          p: 2, 
          bgcolor: 'background.paper', 
          border: 1, 
          borderColor: 'divider', 
          borderRadius: 1, 
          boxShadow: 2,
          zIndex: 1000,
          minWidth: 300
        }}>
          <Typography variant="subtitle2" gutterBottom>
            Environment Configuration
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Current: <strong>{currentEnv}</strong>
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            FaceId API: <code>{config.API_FACEID_URL}</code>
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Control API: <code>{config.API_CONTROL_URL}</code>
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
            To switch environments, set REACT_APP_ENVIRONMENT in your .env file
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default EnvironmentSwitcher;
